import type React from 'react';

import { AboutVisitorView } from '@xing-com/crate-entity-pages-about-reduced';
import { AboutUsContainer } from '@xing-com/crate-entity-pages-about-us';
import { ArticlesModule } from '@xing-com/crate-entity-pages-articles';
import { CompanyRecommendations } from '@xing-com/crate-entity-pages-company-recommendations';
import { ContactsModule } from '@xing-com/crate-entity-pages-contacts';
import { EmployeesModule } from '@xing-com/crate-entity-pages-employees';
import { IdealEmployer } from '@xing-com/crate-entity-pages-ideal-employer';
import { JobsModule } from '@xing-com/crate-entity-pages-jobs';
import { KununuContainer } from '@xing-com/crate-entity-pages-kununu';
import { LocationsContainer } from '@xing-com/crate-entity-pages-location';
import { NewsModule } from '@xing-com/crate-entity-pages-news';

type modulesMapProps = {
  [name: string]: {
    module: React.ComponentType<any>;
    seoIndexSubpage?: boolean;
    featureSwitch?: string;
    tabs?: {
      [tabName: string]: React.ComponentType<any>;
    };
  };
};

export const modulesMap: modulesMapProps = {
  about_insider: {
    module: AboutVisitorView,
  },
  about_us: {
    module: AboutUsContainer,
  },
  jobs: {
    module: JobsModule,
  },
  ideal_employer: {
    module: IdealEmployer,
  },
  news: {
    module: NewsModule,
  },
  articles: {
    module: ArticlesModule,
  },
  contacts: {
    module: ContactsModule,

    seoIndexSubpage: false,
  },
  kununu: {
    module: KununuContainer,
  },
  employees: {
    module: EmployeesModule,
  },
  company_recommendations: {
    module: CompanyRecommendations,
  },
  sampleModule: {
    module: () => <h1>Sample Module</h1>,

    tabs: {
      tab1: () => <h1>tab 1</h1>,
      tab2: () => <h1>tab 2</h1>,
      tab3: () => <h1>tab 3</h1>,
    },
  },
  locations: {
    // module: Locations,
    module: LocationsContainer,
  },
};
